import * as React from 'react';
import { compose, pure, withHandlers } from 'recompose';
import NumberFormat from 'react-number-format';
import MuiTextField from '@material-ui/core/TextField';
import { createStyles, withStyles } from '@material-ui/styles';
import InputAdornment from '@material-ui/core/InputAdornment';
const styles = (theme) => createStyles({
    root: {},
    label: {
        fontWeight: theme.font.weight.normal,
    },
    suffix: {
        fontSize: theme.font.size.mediumSmall,
        opacity: 0.58,
        marginLeft: theme.space.margin.smallest,
        whiteSpace: 'nowrap',
    },
});
const useUpdatedInput = (newVal, touched, setInputValue) => React.useEffect(() => {
    if (!touched) {
        setInputValue((val) => {
            return { ...val, value: newVal };
        });
    }
}, [newVal, touched]);
const NumeralInput = (props) => {
    const { postLabel, min, max, testId = 'NumeralInput', input = {}, meta: { touched, error, invalid } = { touched: false, error: false, invalid: false }, classes = {}, InputLabelProps: InputLabelProperties = {}, InputProps: InputProperties = {}, inputProps, normalizeOnBlur, placeholder, label, allowNegative = false, ref, blurHandler, validationHandler, isNumeric = true, ...rest } = props;
    const [inputValue, setInputValue] = React.useState({
        value: input.value || '',
    });
    useUpdatedInput(input.value, touched, setInputValue);
    return (React.createElement(NumberFormat, Object.assign({ "data-testid": `${testId}`, customInput: MuiTextField, InputLabelProps: { shrink: true, classes: { root: classes.label }, ...InputLabelProperties }, InputProps: {
            endAdornment: postLabel && (React.createElement(InputAdornment, { classes: {
                    root: classes.suffix,
                }, disableTypography: true, position: "end" }, postLabel)),
            ...InputProperties,
        }, value: inputValue.value, onValueChange: setInputValue, placeholder: placeholder, label: label, allowNegative: allowNegative, onBlur: (e) => blurHandler(e, inputValue), isAllowed: validationHandler, error: touched && invalid, helperText: touched && error, isNumericString: isNumeric }, rest)));
};
const ComposedNumeralInput = compose(withStyles(styles, { withTheme: true }), pure, withHandlers({
    validationHandler: (props) => (inputValue) => {
        const { floatValue: val } = inputValue;
        const hasMin = typeof props.min !== undefined;
        const hasMax = typeof props.max !== undefined;
        const hasRange = hasMin || hasMax;
        if (val) {
            if (!isNaN(val) && isFinite(val) && hasRange) {
                const min = hasMin ? props.min : -Infinity;
                const max = hasMax ? props.max : Infinity;
                if (val < min || val > max) {
                    return false;
                }
            }
        }
        return true;
    },
    blurHandler: (props) => (event, inputValue) => {
        event.target.value = inputValue.value;
        if (props.input) {
            props.input.onBlur(event);
        }
    },
}))(NumeralInput);
ComposedNumeralInput.displayName = 'NumeralInput';
export default ComposedNumeralInput;
//# sourceMappingURL=NumeralInput.js.map